import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverallActionPlanService {
  // mClassificationTypes: any[] = [
  //   { Name: 'Man', Id: 1 },
  //   { Name: 'Material', Id: 2 },
  //   { Name: 'Method', Id: 3 },
  //   { Name: 'Machine', Id: 4 },
  // ];

  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {}

  GetActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/GetActionPlan',
      data
    );
  }
  getNewModule() {
    return this.http.get<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/getModule'
    );
  }
  addActionCompleted(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddActionCompleted',
      data
    );
  }
  addNewTargetDate(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddNewTargetDate',
      data
    );
  }

  addRevisedDate(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddRevisedDate',
      data
    );
  }
  AddApprovedAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddRevisedDate',
      data
    );
  }

  getMClassification(): Observable<any[]> {
    return this.http.get<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/GetMClassification'
    );
  }

  editActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/UpdateActonPlan',
      data
    );
  }

  sendMail(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'EdgeData/SendEmail', data);
  }
  addActionPlan(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddActionPlan',
      data
    );
  }
  AddActionUserAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'OverallActionPlan/AddActionUserAction',
      data
    );
  }
}
